import { Box, alpha, useTheme } from '@mui/material';
import logoRefer from '@public/logo-refer.png';
import type { FC } from 'react';

import { ListItem, ListItemButton, ListItemText } from '../AppNavigation/styles';

type ReferButtonProps = {
  onClick(): void;
  isOpen: boolean;
};

export const ReferButton: FC<ReferButtonProps> = ({ isOpen, onClick }) => {
  const theme = useTheme();

  return (
    <ListItem disablePadding>
      <ListItemButton
        sx={{
          margin: isOpen ? '8px 20px' : '8px',
          padding: 1,
          position: 'relative',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
        isOpen={isOpen}
        onClick={onClick}
      >
        {isOpen && (
          <ListItemText
            sx={{
              margin: 0,
              marginBottom: 0.5,
              span: {
                margin: 0,
                lineHeight: '28px',
                fontWeight: 500,
                fontSize: 24,
                color: theme.palette.SlabYellow[500],
              },
            }}
            isOpen={isOpen}
          >
            $250
          </ListItemText>
        )}
        {isOpen && (
          <ListItemText
            sx={{
              margin: 0,
              span: {
                margin: 0,
                lineHeight: '20px',
                fontWeight: 400,
                fontSize: 18,
                color: theme.palette.common.white,
              },
            }}
            isOpen={isOpen}
          >
            Refer & Earn
          </ListItemText>
        )}

        <Box
          sx={{
            borderRadius: 2,
            borderColor: theme.palette.SlabGray[500],
            borderWidth: 1,
            borderStyle: 'solid',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: alpha(theme.palette.common.white, 0.16),
            backgroundImage: `url(${logoRefer})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: isOpen ? '115% 50%' : '50%',
            backgroundSize: isOpen ? 'auto 140%' : 'auto 70%',
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};
